<script>
import { defineComponent, computed, useAttrs } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { omit } from 'lodash';
import { theme } from '@/../tailwind.config';
import { bnum } from '@/lib/utils';
import useNumbers from '@/composables/useNumbers';

export default defineComponent({
  components: {
    VueSlider
  },
  emits: ['change', 'update:modelValue', 'dragEnd', 'update:isValid'],
  props: {
    modelValue: { type: [String, Number], default: '0' },
    hasBar: { type: [Boolean, undefined], default: false },
    barName: { type: String, default: '' },
    changeType: { type: String, default: '' },
    amount: { type: String },
    userInfos: { type: Object },
    actionType: { type: Number, default: 0 }
  },
  setup(props) {
    const attrs = useAttrs();
    const inputAttrs = computed(() => omit(attrs, 'class'));
    const { fNum } = useNumbers();
    const colors = theme.extend.colors;
    const dotStyle = computed(() => ({
      backgroundColor: colors['custom-green']['50'],
      borderColor: colors.blue['500'],
      borderWidth: 0
    }));
    const railSyle = computed(() => ({
      background: colors['custom-black']['300']
    }));
    const proccessStyle = computed(() => ({
      backgroundColor: colors['custom-green']['50']
    }));
    const borderCls = computed(() => {
      if (props.changeType === 'boost') {
        return 'border-custom-green-50';
      }
      return 'border-custom-blue-50';
    });
    const curSpeed = computed(() => {
      if (props.userInfos) {
        if (
          props.userInfos.boostDecimals &&
          props.userInfos.boostStaked !== '0' &&
          props.userInfos.boostDecimals !== '0'
        ) {
          const data = bnum(props.userInfos.boostRatio || '0')
            .dividedBy(props.userInfos.boostDecimals)
            .minus(1)
            .times(100);
          return data.lt(1) ? '0' : data.toFixed(1);
        } else {
          return '0';
        }
      } else {
        return '0';
      }
    });

    function calcCoefficient(value) {
      let coefficient;
      if (props.actionType === 0) {
        coefficient =
          Math.log(
            bnum(Number(value) + 500000)
              .times(Math.pow(10, 18))
              .plus(props.userInfos.boostStaked)
          ) /
            Math.log(5) -
          32.9 -
          1;
      } else {
        coefficient =
          Math.log(
            bnum(props.userInfos.boostStaked)
              .dividedBy(Math.pow(10, 18))
              .minus(value)
              .plus(500000)
              .times(Math.pow(10, 18))
          ) /
            Math.log(5) -
          32.9 -
          1;
      }

      const num = bnum(coefficient).times(100);
      const data = num.lt(1) ? bnum(0) : num;
      return data;
    }

    return {
      dotStyle,
      railSyle,
      proccessStyle,
      inputAttrs,
      borderCls,
      fNum,
      calcCoefficient,
      curSpeed
    };
  },
  data() {
    return {
      inpValue: '',
      range: this.curSpeed,
      allFlake: this.modelValue
    };
  },
  methods: {
    setMax() {
      this.$emit('setMax');
      this.$emit('update:amount', this.modelValue);
      const data = this.calcCoefficient(this.modelValue).toFixed(1);
      this.$emit('change', data);
      this.range = data;
      this.inpValue = this.modelValue;
      this.updateSliderByInp();
    },
    handleInput(e) {
      const input = e.target.value;
      this.inpValue = input;
      this.$emit('update:amount', input);
      this.updateSliderByInp();
      // this.$emit('update:modelValue', data);
    },
    onChange(value) {
      this.limitSliderRate(value);
      this.updateInpBySlider();
    },
    updateSliderByInp() {
      const data = this.calcCoefficient(
        this.inpValue ? this.inpValue : 0
      ).toString();
      let v = this.limitSliderRate(data);
      this.$emit('change', v);
    },
    updateInpBySlider() {
      // veFlake=5^(加速系数+32.9)-500000*10^18
      const tmp_1 = bnum(500000).times(Math.pow(10, 18));
      const tmp_2 =
        +this.range === 0
          ? bnum(0)
          : bnum(Math.pow(5, Number(this.range / 100 + 1) + 32.9)).minus(tmp_1);
      let tmp_3;
      if (this.actionType === 0) {
        tmp_3 = tmp_2
          .minus(this.userInfos.boostStaked)
          .dividedBy(Math.pow(10, 18));
      } else {
        tmp_3 = bnum(this.userInfos.boostStaked)
          .minus(tmp_2)
          .dividedBy(Math.pow(10, 18));
      }
      const data = tmp_3.lt(0) ? '0' : tmp_3.toString();
      this.$emit('change', data);
      this.inpValue = data;
      this.$emit('update:amount', data);
    },
    limitSliderRate(value) {
      let v = value;
      if (this.actionType === 0) {
        const min =
          this.curSpeed < 1
            ? Number(this.curSpeed) === 0
              ? value
              : 1
            : this.curSpeed;
        const max = 100;
        v = value < min ? min : value;
        v = v > max ? max : v;
      } else {
        const min = 1;
        const max = this.curSpeed;
        v = value < min ? 0 : value;
        v = v > max ? max : v;
      }
      if (v >= 0 && v <= 1 && value >= 0 && value <= 1) {
        v = value >= 0.5 ? 1 : 0;
      }
      v = bnum(v).toFixed(1);
      this.range = v;
      this.$nextTick().then(() => {
        const sliderValue = this.$refs.slider.getValue();
        if (Number(sliderValue) !== Number(v)) this.$refs.slider.setValue(v);
      });
      return v;
    },

    onDragEnd() {
      // emit('dragEnd', props.modelValue);
      this.limitSliderRate(this.range);
      this.updateInpBySlider();
    }
  },
  watch: {
    actionType(n, o) {
      if (n !== o) {
        this.inpValue = '';
        this.range = this.curSpeed;
      }
    }
  }
});
</script>

<template>
  <div class="card">
    <div class="container" :class="borderCls">
      <div>
        <input
          type="text"
          :name="name"
          v-model="inpValue"
          v-bind="inputAttrs"
          :disabled="disabled"
          placeholder="0.0"
          class="input"
          @input="handleInput"
        />
        <!-- <div class="text-sm text-custom-black-350">${{ 0.0 }}</div> -->
      </div>
      <div
        @click="setMax"
        class="right bg-custom-black-100 text cursor-pointer"
      >
        Max
      </div>
    </div>
    <div class="pt-5" v-if="hasBar">
      <div class="flex justify-between">
        <span class="text-sm text-custom-black-350">{{ barName }}</span>
        <span class="text-sm text-custom-black-350">{{ range }}%</span>
      </div>
      <div>
        <vue-slider
          v-model="range"
          v-bind="$attrs"
          @change="onChange"
          @drag-end="onDragEnd"
          :dot-style="dotStyle"
          :rail-style="railSyle"
          :process-style="proccessStyle"
          :interval="0.1"
          :min="actionType === 0 ? curSpeed : '0'"
          :max="actionType === 0 ? '100' : curSpeed"
          ref="slider"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  @apply flex place-content-between;
  @apply rounded border;
  @apply pl-4 pr-4 pt-3 pb-3;
}

.right {
  @apply flex items-center justify-center;
  @apply rounded w-12;
  @apply text-custom-blue-50;
}

.input {
  @apply bg-gray-850 placeholder-custom-black-350;
  caret-color: #4390f8;
  min-height: 2.5rem;
}
</style>
